import React from 'react'
import { useAdvisorsData } from '../../../hooks/useAdvisorsData'
import { useTrackSelfScheduleMatched } from '../../hooks/useTrackSelfScheduleMatched'
import '../../styles/AdvisorCardsModule/AdvisorCardsModule.scss'
import { AdvisorCards } from './AdvisorCards'

export const AdvisorCardsModule = () => {
  const advisorsData = useAdvisorsData()

  useTrackSelfScheduleMatched(advisorsData)

  if (!advisorsData) return null

  return (
    <div className='advisor-cards-module'>
      <AdvisorCards advisorsData={advisorsData}/>
    </div>
  )
}
